<div class="loading min90height" *ngIf="isLoading">
  <div class="loading__icon">
    <svg-icon name="spinner" class="spinner"></svg-icon>
  </div>
</div>

<section class="section" *ngIf="!isLoading">
  <div class="container">
    <h2 class="section__header" *ngIf="showHeader">{{content?.header}}</h2>

    <div *ngIf="body" [innerHTML]="body" [style.fontSize]="(16 + size) + 'px'"></div>

    <div class="pt-4 pb-5"></div>
  </div>
</section>
